/**
 * Converts a date string in dd.MM.yyyy format and time string in HH:mm format
 * to an ISO 8601 datetime string.
 *
 * @param date - Date string in format dd.MM.yyyy (e.g., "09.01.2026")
 * @param time - Time string in format HH:mm (e.g., "14:30")
 * @returns ISO 8601 datetime string (e.g., "2026-01-09T14:30:00.000Z")
 *
 * @example
 * formatToISO("09.01.2026", "14:30") // Returns "2026-01-09T14:30:00.000Z"
 */
export const formatToISO = (date: string, time: string): string => {
  // Parse dd.MM.yyyy format to ISO date
  const [day, month, year] = date.split('.');
  // Combine into ISO 8601 format
  const dateTimeString = `${year}-${month}-${day}T${time}:00`;
  const dateObj = new Date(dateTimeString);
  return dateObj.toISOString();
};
